import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { WarehouseDto } from "../../../../dtos/catalogs/warehouse/WarehouseDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { CostCalculationMethods } from "../../../../enums/CostCalculationMethods";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import WarehouseDetailSkeleton from "./WarehouseDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import WarehouseDetailMain from "./WarehouseDetailMain";
import WarehouseDetailAdditional from "./WarehouseDetailAdditional";

interface IProps {
  model: WarehouseDto | null;
  modelUpdatedEvent: (newModel: WarehouseDto) => void;
}

interface WarehouseModel {
  id: string;
  name: string;
  description?: string;
  createdDate?: Date;
  responsibleId?: string;
  divisionId?: string;
  companyId?: string;
  actualAddress?: string;
  phoneNumber?: string;
}

export const WarehouseDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<WarehouseModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    console.log(model);
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("description", model.description);
      setValue("responsibleId", model.responsibleId);
      setValue("divisionId", model.divisionId);
      setValue("actualAddress", model.actualAddress);
      setValue("companyId", model.companyId);
      setValue("createdDate", model.createdDate);
      setValue("phoneNumber", model.phoneNumber);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: WarehouseModel) => {
    console.log("form submit start");
    console.log(data);
    console.log(action);
    // return;
    if (action === "save") {
      const newModel: WarehouseDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <WarehouseDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Additional"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <WarehouseDetailMain />
        </NFTabContainer>

        <NFTabContainer index={0} currentIndex={tabIndex}>
            <WarehouseDetailAdditional/>
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
